/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState } from "react";
import ImageSection from "../../components/common/ImageSection";
import {
  Edit_icon,
  Envelope_icon,
  Info_icon,
  Location_icon,
  Phone_icon,
  Ring_circle,
  User_icon,
  WhiteLine_envelope,
  WhiteLine_phone,
  White_dots,
  White_edit,
  White_info,
  White_lines,
  White_user,
} from "../../helper/imageConstant";
import axios from "axios";

const ContactUs = ({ homeContact = false, contactUs = true, id }) => {
  const [formData, setFormData] = useState({
    name: "",
    emailAddress: "",
    phoneNo: "",
    subject: "",
    message: "",
  });
  const [formSubmitted, setFormSubmitted] = useState(false);

  const base_URL =
    "https://portalapi.calcue.com/api/Vikas/send_email_vikasfashion";

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isPhoneNumberValid = /^\d{10}$/.test(formData.phoneNo);

    if (!isPhoneNumberValid) {
      alert("Please enter a valid 10-digit phone number");
      return;
    }

    try {
      const response = await axios.post(base_URL, formData);
      console.log("Response:", response);
      setFormSubmitted(true); // Set the formSubmitted state to true on successful form submission
    } catch (error) {
      console.error("Error:", error);
    }

    setTimeout(() => {
      setFormSubmitted(false);
    }, 4000);
  };

  return (
    <>
      {contactUs && (
        <>
          <ImageSection name={"Contact us"} />
          <section className="relative p-4 my-5 lg:my-2 overflow-hidden">
            <div className="lg:mx-20 xl:mx-14 2xl:mx-48 3xl:mx-64 4xl:max-w-[1520px] 4xl:mx-auto ">
              <div className="grid grid-cols-6 lg:grid-cols-12 lg:gap-20">
                <div className="col-span-6 lg:col-span-5">
                  <div className="mt-5 mb-10 lg:mb-8 w-full flex flex-col gap-4 lg:gap-4 2xl:gap-6 3xl:gap-8">
                    <div className="">
                      <span
                        className="py-2 px-3 sm:py-2 sm:px-4 bg-[#A5302E] text-white text-xs xs:text-sm md:text-base
                   lg:text-xs uppercase leading-none"
                      >
                        Contact us
                      </span>
                    </div>
                    <div className="">
                      <h3 className="text-[#A5302E] text-[38px] font-normal leading-tight lg:leading-tight">
                        Have Questions? <br className="" />
                        Get in Touch <span className="fonts">!</span>
                      </h3>
                    </div>
                    <p
                      className="text-[#555555] font-normal text-base md:text-lg lg:text-lg xl:text-base 3xl:text-xl
                 lg:leading-relaxed 3xl:leading-relaxed"
                    >
                      Have inquiries or need assistance? We are here to help,
                      just a message away.
                    </p>
                    <ul className="fonts flex flex-col gap-3 list-none text-[#080808] text-base md:text-lg lg:text-lg xl:text-base 3xl:text-xl">
                      <li className="py-1 flex justify-start items-start gap-5">
                        <img
                          src={Location_icon}
                          alt="Location_icon"
                          className="mt-2 w-[31px] "
                        />
                        <h4 className="xs:pr-5 sm:pr-0">
                          B-3033-3034, 1st Floor, Millennium Market, Ring Road,
                          Surat-395002
                        </h4>
                      </li>
                      <li className="py-1 flex justify-start items-start gap-5">
                        <img
                          src={Phone_icon}
                          alt="Phone_icon"
                          className="mt-2"
                        />

                        <h4 className="">
                          +91 261 2320920 <br /> +91 261 3250920
                        </h4>
                      </li>
                      <li className="py-1 flex items-center gap-5">
                        <img
                          src={Envelope_icon}
                          alt="Envelope_icon"
                          className=""
                        />

                        <h4 className="">info@vikasfashion.com</h4>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-span-6 lg:col-span-7 my-auto flex justify-center items-center">
                  <form
                    action=""
                    autoComplete="off"
                    autoFocus="off"
                    className="w-full h-full"
                    onSubmit={handleSubmit}
                  >
                    <div className="lg:mb-8 grid xl:grid-cols-2 xl:gap-6">
                      <div className="relative z-0 mb-4 lg:mb-6 w-full group">
                        <input
                          type="text"
                          name="name"
                          className="pl-10 block py-2.5 px-0 w-full text-base text-[#555555] bg-transparent border-0 border-b-2
                       border-[#929292] appearance-none
                         focus:outline-none focus:ring-0 focus:border-[#A5302E] peer"
                          placeholder=" "
                          required
                          value={formData.name}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              name: e.target.value,
                            });
                          }}
                        />
                        <img
                          src={User_icon}
                          alt=""
                          className="w-5 3xl:w-5 absolute top-3 left-2"
                        />
                        <label
                          htmlFor="floating_first_name"
                          className="pl-12 absolute text-xs xs:text-sm md:text-base 3xl:text-xl text-[#555555]  duration-300 transform -translate-y-6 scale-75 top-3 
                      -z-10 origin-[0] peer-focus:left-0 peer-focus:text-[#A5302E]  peer-placeholder-shown:scale-100 
                      peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                        >
                          Name
                        </label>
                      </div>
                      <div className="relative z-0 mb-4 lg:mb-0 xl:mb-0 w-full group">
                        <input
                          type="email"
                          name="emailAddress"
                          className="pl-10 block py-2.5 px-0 w-full text-base text-[#555555] bg-transparent border-0 border-b-2
                      border-[#929292] appearance-none
                        focus:outline-none focus:ring-0 focus:border-[#A5302E] peer"
                          placeholder=" "
                          required
                          value={formData.emailAddress}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              emailAddress: e.target.value,
                            });
                          }}
                        />
                        <img
                          src={Envelope_icon}
                          alt=""
                          className="w-5 3xl:w-6 absolute top-3 left-2"
                        />
                        <label
                          htmlFor="floating_last_name"
                          className="pl-12 absolute text-xs xs:text-sm md:text-base 3xl:text-xl text-[#555555]  duration-300 transform -translate-y-6 scale-75 top-3
                       -z-10 origin-[0] peer-focus:left-0 peer-focus:text-[#A5302E]  peer-placeholder-shown:scale-100 
                       peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                        >
                          Email Address
                        </label>
                      </div>
                    </div>
                    <div className="lg:mb-0 xl:mb-8 grid xl:grid-cols-2 xl:gap-6">
                      <div className="relative z-0 mb-4 lg:mb-6 w-full group">
                        <input
                          type="number"
                          name="phoneNo"
                          pattern="^\d{10}$"
                          className="pl-10 block py-2.5 px-0 w-full text-base text-[#555555] bg-transparent border-0 border-b-2
                      border-[#929292] appearance-none
                        focus:outline-none focus:ring-0 focus:border-[#A5302E] peer"
                          placeholder=" "
                          required
                          value={formData.phoneNo}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              phoneNo: e.target.value,
                            });
                          }}
                        />
                        <img
                          src={Phone_icon}
                          alt=""
                          className="w-5 3xl:w-6 absolute top-3 left-2"
                        />
                        <label
                          htmlFor=""
                          className="pl-12 absolute text-xs xs:text-sm md:text-base 3xl:text-xl text-[#555555]  duration-300 transform -translate-y-6 scale-75 top-3 
                      -z-10 origin-[0] peer-focus:left-0 peer-focus:text-[#A5302E]  peer-placeholder-shown:scale-100 
                      peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                        >
                          Phone
                        </label>
                      </div>
                      <div className="relative z-0 mb-4 lg:mb-6 w-full group">
                        <input
                          type="text"
                          name="subject"
                          className="pl-10 block py-2.5 px-0 w-full text-base text-[#555555] bg-transparent border-0 border-b-2
                      border-[#929292] appearance-none
                        focus:outline-none focus:ring-0 focus:border-[#A5302E] peer"
                          placeholder=" "
                          required
                          value={formData.subject}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              subject: e.target.value,
                            });
                          }}
                        />
                        <img
                          src={Info_icon}
                          alt=""
                          className="w-5 3xl:w-6 absolute top-3 left-2"
                        />
                        <label
                          htmlFor="floating_last_name"
                          className="pl-12 absolute text-xs xs:text-sm md:text-base 3xl:text-xl text-[#555555]  duration-300 transform -translate-y-6 scale-75 top-3 
                      -z-10 origin-[0] peer-focus:left-0 peer-focus:text-[#A5302E]  peer-placeholder-shown:scale-100 
                      peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                        >
                          Subject
                        </label>
                      </div>
                    </div>

                    <div className="relative z-0 mb-4 lg:mb-4 w-full group">
                      <input
                        type="text"
                        name="message"
                        className="pl-10 block py-2.5 px-0 w-full text-base text-[#555555] bg-transparent border-0 border-b-2
                    border-[#929292] appearance-none
                      focus:outline-none focus:ring-0 focus:border-[#A5302E] peer"
                        placeholder=" "
                        required
                        value={formData.message}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            message: e.target.value,
                          });
                        }}
                      />
                      <img
                        src={Edit_icon}
                        alt=""
                        className="w-5 3xl:w-6 absolute top-3 left-2"
                      />
                      <label
                        htmlFor="floating_repeat_password"
                        className="pl-12 absolute text-xs xs:text-sm md:text-base 3xl:text-xl text-[#555555]  duration-300 transform -translate-y-6 scale-75 top-3 
                    -z-10 origin-[0] peer-focus:left-0 peer-focus:text-[#A5302E]  peer-placeholder-shown:scale-100 
                    peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                      >
                        How can we help you? Feel free ot get in touch!
                      </label>
                    </div>
                    <div className="mt-10 flex flex-col lg:flex-row items-start justify-start lg:items-center gap-5 xl:gap-10">
                      <div className="order-2 lg:order-1">
                        <button
                          type="submit"
                          className="py-3 px-10 sm:py-2 sm:px-6 md:py-2 md:px-8 lg:py-2.5 lg:px-8 hover:lg:py-2.5 hover:lg:px-8 xl:py-2.5 xl:px-8 hover:xl:py-2.5 hover:xl:px-8 bg-[#A5302E]
                    text-[#fff] border border-transparent hover:bg-transparent hover:border hover:border-[#A5302E] hover:text-[#A5302E]
                    text-base md:text-lg lg:text-xs xl:text-base 3xl:text-[18px] transition "
                        >
                          GET IN TOUCH
                        </button>
                      </div>

                      <div className="flex items-center justify-start gap-5 lg:gap-4 order-1 lg:order-2">
                        <input
                          type="checkbox"
                          id="checkbox"
                          className="relative peer shrink-0 appearance-none w-4 h-4 border-2 border-[#A5302E] rounded-sm bg-transparent checked:[#A5302E]  disabled:border-[#A5302E] disabled:bg-[#A5302E] checked:border-2 checked:border-[#A5302E]"
                        />
                        <label
                          htmlFor=""
                          className="text-sm md:text-base lg:text-sm xl:text-base text-[#555555] leading-none"
                        >
                          I agree that my data is collected and stores.
                        </label>
                        <svg
                          className="absolute w-4 h-4 hidden text-[#A5302E] peer-checked:block pointer-events-none"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                      </div>
                    </div>
                    {formSubmitted && (
                      <div className="mt-4 bg-[#A5302E] text-[#fff] text-center  p-2 mb-4">
                        Form submitted successfully!
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
            <div className="circle_line absolute top-[30%] xs:top-[32%] xs:-right-[22%] md:top-[30%] md:-right-[13%] lg:top-[70%] lg:-right-[9%] xl:top-[62%] xl:-right-[8%]  3xl:bottom-0 3xl:-right-[7%]">
              <div className="w-40 md:w-44 lg:w-40 2xl:w-56 xl:w-44 3xl:w-60 h-full">
                <img src={Ring_circle} alt="" className="object-cover" />
              </div>
            </div>
          </section>
          <section className="relative p-2 overflow-hidden">
            <div className="w-full h-full">
              <iframe
                className="w-full h-[400px] lg:h-[400px]"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39951.0202587288!2d72.871505897648!3d21.176547756619257!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04e4e0e8573fb%3A0xee5f820496068af3!2sVikas%20Fashions%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1703841169463!5m2!1sen!2sin"
                allowFullScreen="on"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </section>
        </>
      )}
      {homeContact && (
        <section
          id={id}
          className="p-4 lg:p-0 relative lg:py-40 bg-[#A5302E] overflow-hidden"
        >
          <div className="4xl:max-w-[1360px] 4xl:mx-auto my-5 lg:mx-20 xl:mx-14 2xl:mx-52 3xl:mx-64">
            <div className="mt-16 lg:mt-0 grid grid-cols-6 lg:grid-cols-12 lg:gap-20">
              <div className="col-span-6 lg:col-span-5">
                <div className="lg:mb-8 w-full lg:p-4 flex flex-col items-start justify-start gap-4 lg:gap-4 2xl:gap-6 3xl:gap-8">
                  <div className="">
                    <span
                      className="py-2 px-3 sm:py-2 sm:px-4 text-[#A5302E] bg-[#FFF0F0] text-xs xs:text-sm md:text-base
                   lg:text-base uppercase leading-none"
                    >
                      Contact us
                    </span>
                  </div>
                  <div className="">
                    <h3 className="text-[#FFF0F0] text-3xl xs:text-[36px] lg:text-[40px] xl:text-5xl font-normal leading-tight lg:leading-tight">
                      Have Questions? <br className="" />
                      Get in Touch <span className="fonts">!</span>
                    </h3>
                  </div>
                  <p
                    className="text-[#FFF0F0] font-normal text-xs xs:text-base md:text-lg lg:text-lg xl:text-base 3xl:text-xl
                 lg:leading-relaxed 3xl:leading-relaxed"
                  >
                    Have inquiries or need assistance? We are here to help, just
                    a message away.
                  </p>
                </div>
              </div>
              <div className="mt-10 md:mt-16 lg:mt-0 col-span-6 lg:col-span-7 my-auto flex justify-center items-center">
                <form
                  action=""
                  autoComplete="off"
                  autoFocus="off"
                  className="w-full h-full"
                  onSubmit={handleSubmit}
                >
                  <div className="mt-10 lg:mt-0 lg:mb-8 grid xl:grid-cols-2 xl:gap-6">
                    <div className="relative z-0 mb-4 lg:mb-6 w-full group">
                      <input
                        type="text"
                        name="name"
                        className="pl-10 block py-2.5 px-0 w-full text-base text-[#FFF0F0] bg-transparent border-0 border-b-2
                       border-[#FFFFFF] appearance-none
                         focus:outline-none focus:ring-0 focus:border-[#FFFFFF] peer"
                        placeholder=" "
                        required
                        autoComplete="off"
                        value={formData.name}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            name: e.target.value,
                          });
                        }}
                      />
                      <img
                        src={White_user}
                        alt=""
                        className="w-5 3xl:w-5 absolute top-3 left-2"
                      />
                      <label
                        htmlFor="floating_first_name"
                        className="pl-12 absolute text-xs xs:text-sm md:text-base 3xl:text-2xl text-[#FFF0F0]  duration-300 transform -translate-y-6 scale-75 top-2 
                      -z-10 origin-[0] peer-focus:left-0 peer-focus:text-[#FFFFFF]  peer-placeholder-shown:scale-100 
                      peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                      >
                        Name
                      </label>
                    </div>
                    <div className="relative z-0 mb-4 lg:mb-6 w-full group">
                      <input
                        type="email"
                        name="emailAddress"
                        className="pl-10 block py-2.5 px-0 w-full text-base text-[#FFF0F0] bg-transparent border-0 border-b-2
                      border-[#FFFFFF] appearance-none
                        focus:outline-none focus:ring-0 focus:border-[#FFFFFF] peer"
                        placeholder=" "
                        required
                        autoComplete="off"
                        value={formData.emailAddress}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            emailAddress: e.target.value,
                          });
                        }}
                      />
                      <img
                        src={WhiteLine_envelope}
                        alt=""
                        className="w-5 3xl:w-6 absolute top-3 left-2"
                      />
                      <label
                        htmlFor="floating_last_name"
                        className="pl-12 absolute text-xs xs:text-sm md:text-base 3xl:text-2xl text-[#FFF0F0]  duration-300 transform -translate-y-6 scale-75 top-2
                       -z-10 origin-[0] peer-focus:left-0 peer-focus:text-[#FFFFFF]  peer-placeholder-shown:scale-100 
                       peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                      >
                        Email Address
                      </label>
                    </div>
                  </div>
                  <div className="lg:mb-8 grid xl:grid-cols-2 xl:gap-6">
                    <div className="relative z-0 mb-4 lg:mb-6 w-full group">
                      <input
                        type="number"
                        name="phoneNo"
                        className="pl-10 block py-2.5 px-0 w-full text-base text-[#FFF0F0] bg-transparent border-0 border-b-2
                      border-[#FFFFFF] appearance-none
                        focus:outline-none focus:ring-0 focus:border-[#FFFFFF] peer"
                        placeholder=" "
                        required
                        autoComplete="off"
                        value={formData.phoneNo}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            phoneNo: e.target.value,
                          });
                        }}
                      />
                      <img
                        src={WhiteLine_phone}
                        alt=""
                        className="w-5 3xl:w-6 absolute top-3 left-2"
                      />
                      <label
                        htmlFor=""
                        className="pl-12 absolute text-xs xs:text-sm md:text-base 3xl:text-2xl text-[#FFF0F0]  duration-300 transform -translate-y-6 scale-75 top-2 
                      -z-10 origin-[0] peer-focus:left-0 peer-focus:text-[#FFFFFF]  peer-placeholder-shown:scale-100 
                      peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                      >
                        Phone
                      </label>
                    </div>
                    <div className="relative z-0 mb-4 lg:mb-6 w-full group">
                      <input
                        type="text"
                        name="subject"
                        className="pl-10 block py-2.5 px-0 w-full text-base text-[#FFF0F0] bg-transparent border-0 border-b-2
                      border-[#FFFFFF] appearance-none
                        focus:outline-none focus:ring-0 focus:border-[#FFFFFF] peer"
                        placeholder=" "
                        required
                        autoComplete="off"
                        value={formData.subject}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            subject: e.target.value,
                          });
                        }}
                      />
                      <img
                        src={White_info}
                        alt=""
                        className="w-5 3xl:w-6 absolute top-3 left-2"
                      />
                      <label
                        htmlFor="floating_last_name"
                        className="pl-12 absolute text-xs xs:text-sm md:text-base 3xl:text-2xl text-[#FFF0F0]  duration-300 transform -translate-y-6 scale-75 top-2 
                      -z-10 origin-[0] peer-focus:left-0 peer-focus:text-[#FFFFFF]  peer-placeholder-shown:scale-100 
                      peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                      >
                        Subject
                      </label>
                    </div>
                  </div>

                  <div className="relative z-0 mb-4 lg:mb-4 w-full group">
                    <input
                      type="text"
                      name="messgae"
                      className="pl-10 block py-2.5 px-0 w-full text-base text-[#FFF0F0] bg-transparent border-0 border-b-2
                    border-[#FFFFFF] appearance-none
                      focus:outline-none focus:ring-0 focus:border-[#FFFFFF] peer"
                      placeholder=" "
                      required
                      autoComplete="off"
                      value={formData.message}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          message: e.target.value,
                        });
                      }}
                    />
                    <img
                      src={White_edit}
                      alt=""
                      className="w-5 3xl:w-6 absolute top-3 left-2"
                    />
                    <label
                      htmlFor="floating_repeat_password"
                      className="pl-12 absolute text-xs xs:text-sm md:text-base 3xl:text-2xl text-[#FFF0F0]  duration-300 transform -translate-y-6 scale-75 top-2 
                    -z-10 origin-[0] peer-focus:left-0 peer-focus:text-[#FFFFFF]  peer-placeholder-shown:scale-100 
                    peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                    >
                      How can we help you? Feel free ot get in touch!
                    </label>
                  </div>
                  <div className="mt-10 flex flex-col lg:flex-row items-start justify-start lg:items-center gap-5 xl:gap-10">
                    <div className="order-2 lg:order-1">
                      <button
                        type="submit"
                        className="py-3 px-10 sm:py-2 sm:px-6 md:py-2 md:px-8 lg:py-2.5 lg:px-8 hover:lg:py-2.5 hover:lg:px-8 bg-[#FFF0F0]
                    text-[#A5302E] border border-transparent hover:bg-transparent hover:border hover:border-[#FFF0F0] hover:text-[#FFF0F0]
                    text-base md:text-lg lg:text-xs xl:text-base 3xl:text-[18px] transition cursor-pointer"
                      >
                        GET IN TOUCH
                      </button>
                    </div>
                    <div className="flex items-center justify-start gap-5 lg:gap-4 order-1 lg:order-2">
                      <input
                        type="checkbox"
                        id="checkbox"
                        className="relative peer shrink-0 appearance-none w-4 h-4 border-2 border-[#FFF0F0] rounded-sm bg-transparent checked:[#FFF0F0]  disabled:border-[#FFF0F0] disabled:bg-[#FFF0F0] checked:border-2 checked:border-[#FFF0F0]"
                      />
                      <label
                        htmlFor=""
                        className="text-sm md:text-base lg:text-sm xl:text-base text-[#FFF0F0] leading-none"
                      >
                        I agree that my data is collected and stores.
                      </label>
                      <svg
                        className="absolute w-4 h-4 hidden text-[#FFF0F0] peer-checked:block pointer-events-none"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="absolute top-[32%] xs:top-[35%] right-[20%] md:top-[35%] lg:top-[5%] lg:right-[5%]  xl:top-[5%] xl:right-[5%] 2xl:top-[20%] 2xl:right-[5%]">
            <div className="w-10 lg:w-16 2xl:w-full">
              <img src={White_lines} alt="" className="object-cover" />
            </div>
          </div>
          <div className="absolute top-[3%] right-[7%] md:top-[] lg:-top-8 lg:left-8 ">
            <div className="w-10 lg:w-48">
              <img src={White_dots} alt="" className="object-cover" />
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default ContactUs;
